import React from 'react';
import { useAccountPlansCount } from 'hooks/use-account-plans-count.hook';
import { LoadingPage } from 'components/loading';
import { ErrorPage } from 'components/errors';
import * as States from './states';

export const SettingsPage = () => {
  const plansCount = useAccountPlansCount();

  if (plansCount.error) return <ErrorPage />;
  if (plansCount.loading) return <LoadingPage />;

  const isWhale = plansCount?.data?.isPlanWhale || false;
  const nonVNMtoVNMMoveRequest =
    localStorage.getItem('nonVNMtoVNMMoveRequest') === 'true';
  return !plansCount.data?.active || nonVNMtoVNMMoveRequest ? (
    <States.Closed />
  ) : (
    <States.Active isWhale={isWhale} />
  );
};
